



































































import Vue from 'vue'
import { EventBus } from '../utils'
import Footer from '../components/Footer.vue'
import Sharer from '../components/Sharer.vue'
import Gallery from '../components/Gallery.vue'
import ReadMore from '../components/ReadMore.vue'

interface CData {
  animationStatus: boolean
  hide: boolean
  lightboxCaption: string
  lightboxAlt: string
  lightboxLargeImage: string
}
interface CMethods {
  setEvents(): void
  showPopup(payload: {}): void
  getImageOnClick(imgId: any): any
  getDataForImageLightbox(res: any): void
}
interface CComputed {
  routeName?: string | null
  allContent: any
  subHeading: string
  title: string
  content: string
  gallery: string
  image: string
  browsableRoutes: any[]
  isBrowsableRoute: boolean
  prevRoute: string
  nextRoute: string
  parentRoute: any
}

export default Vue.extend<CData, CMethods, CComputed, {}>({
  name: 'ChildPage',
  data() {
    return {
      animationStatus: true,
      hide: true,
      lightboxCaption: '',
      lightboxAlt: '',
      lightboxLargeImage: ''
    }
  },
  components: {
    Sharer,
    ReadMore,
    Gallery,
    Footer
  },
  mounted() {
    this.hide = false
    this.$nextTick(() => {
      this.setEvents()
    })
    EventBus.$on('hide-hero', () => (this.hide = true))
  },
  props: {},
  watch: {
    routeName: function() {
      /**
       * Resets animation status
       * for css animation to be re-triggered
       */
      const self = this
      new Promise((resolve: any) => {
        self.animationStatus = false
        resolve()
      }).then(() => {
        self.animationStatus = true
        self.hide = false
      })
    },
    content() {
      this.$nextTick(() => {
        this.setEvents()
      })
    }
  },
  methods: {
    async getImageOnClick(imgId){
        try {
          const response = await fetch('/wp-json/wp/v2/media/' + imgId);
          return await response.json();
        } catch (e) {
          return e;
        }
    },
    getDataForImageLightbox( res ) {
      if( res.caption.rendered ) {
        let caption = res.caption.rendered.replace("<p>", "").replace("</p>", "");
        this.lightboxCaption = caption;
      }
      if( res.alt_text ) {
        let altText = res.alt_text;
        this.lightboxAlt = altText;
      }
      if( res.media_details.sizes.large.source_url ){
        let largeImage = res.media_details.sizes.large.source_url;
        this.lightboxLargeImage = largeImage;
      }
    },
    setEvents() {
      const imageLinks = Array.from(
        document.querySelectorAll(
          '.wp-block-gallery a, a[data-type="imagePopup"]'
        )
      ) as HTMLElement[]

      imageLinks.forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault()
          const { target } = event; 
          if( target && !link.getAttribute('data-type')) { 
            let imgId = (target as HTMLImageElement).getAttribute("data-id");
            if( !imgId ) {
              imgId = link.children[0].getAttribute("data-id");
            } 
            this.getImageOnClick(imgId).then( (resultData: any) => {
                  this.getDataForImageLightbox(resultData);
                  this.showPopup({
                    hidden: false,
                    src: !this.lightboxLargeImage ? link.getAttribute('href') : this.lightboxLargeImage,
                    caption: this.lightboxCaption,
                    alt: this.lightboxAlt 
                  })
            }); 
          }
          const linkImage = link.querySelector('img')
          if( link.getAttribute('data-type') == "imagePopup") {
            this.showPopup({
              hidden: false,
              src: link.getAttribute('href'),
              caption: link.dataset?.caption,
              alt: link.dataset?.alt
            })
          }
        })
      })
    },
    showPopup(payload) {
      this.$store.dispatch({
        type: 'imagePopup',
        payload
      })
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    allContent() {
      return this.$store.getters.pageContent(this.routeName)
    },
    subHeading() {
      return this.allContent.subHeading
    },
    title() {
      return this.allContent.title
    },
    content() {
      return this.allContent.content
    },
    gallery() {
      return this.allContent.gallery
    },
    image() {
      return this.allContent.image
    },
    browsableRoutes() {
      const routes = this.$store.getters.routes.filter(
        (item: any) => item.level <= 2
      )
      return routes
    },
    isBrowsableRoute() {
      const route = this.$store.getters.routes.find(
        (item: any) => item.name === this.$route.name
      )
      return this.browsableRoutes.some(item => item.name === route.name)
    },
    prevRoute() {
      const routes = this.browsableRoutes
      const currentRouteIndex = this.$store.getters.routes.findIndex(
        (route: any) => route.name === this.routeName
      )
      return routes[currentRouteIndex - 1]?.name
    },
    nextRoute() {
      const routes = this.browsableRoutes
      const currentRouteIndex = this.$store.getters.routes.findIndex(
        (route: any) => route.name === this.routeName
      )
      return routes[currentRouteIndex + 1]?.name
    },
    parentRoute() {
      const currentRouteIndex = this.$store.getters.routes.findIndex(
        (route: any) => route.name === this.routeName
      )
      const currentRoute = this.$store.getters.routes[currentRouteIndex]
      let parentRouteName: any = null
      if (Number(currentRoute.level) > 2) {
        parentRouteName = currentRoute.name
          .split('/')
          .slice(0, -1)
          .join('/')

        const parentRoute = this.$store.getters.routes.find(
          (route: any) => route.name === parentRouteName
        )

        return { title: parentRoute.title, routeName: parentRouteName }
      }

      return null
    }
  }
})
